import { render, staticRenderFns } from "./AddTestPaperModal.vue?vue&type=template&id=74d63932&scoped=true"
import script from "./AddTestPaperModal.vue?vue&type=script&lang=js"
export * from "./AddTestPaperModal.vue?vue&type=script&lang=js"
import style0 from "./AddTestPaperModal.vue?vue&type=style&index=0&id=74d63932&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d63932",
  null
  
)

export default component.exports